import { ACCOUNT_ACTION_IDS } from '@central-products/interface-account-actions';
import { openLink } from '../utils';

export const handleNavigationRequests = (bootstrapperFeatures) =>
  bootstrapperFeatures['account-actions'].onActionRequested(({ actionId, data }) => {
    if (actionId === ACCOUNT_ACTION_IDS.NAVIGATE_TO) {
      openLink(data);
    }
  });
